export const HlrPaths = {
	SignIn: 'sign-in',
} satisfies Record<string, string>